import { render, staticRenderFns } from "./GoogleReviewPage.vue?vue&type=template&id=2d392cb4&scoped=true"
import script from "./GoogleReviewPage.vue?vue&type=script&lang=js"
export * from "./GoogleReviewPage.vue?vue&type=script&lang=js"
import style0 from "./GoogleReviewPage.vue?vue&type=style&index=0&id=2d392cb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d392cb4",
  null
  
)

export default component.exports